export { default } from './CorrespondenceCopyScreen';
